import React, { useEffect, useState } from 'react';
import { api } from '../../App';
import { toast } from 'sonner';
import { Switch } from '../ui/switch';
import { Card, CardContent } from '../ui/card';
import { Mail } from 'lucide-react';

export const WeeklyUpdateToggle = () => {
  const [enabled, setEnabled] = useState(null);
  useEffect(() => { api.get('/sb-live/weekly-update').then((r) => setEnabled(r.data.enabled)).catch(() => {}); }, []);

  const toggle = async (value) => {
    setEnabled(value);
    try {
      await api.put('/sb-live/weekly-update', { enabled: value });
      toast.success(value ? 'Weekly investor update turned on' : 'Weekly investor update turned off');
    } catch {
      setEnabled(!value);
      toast.error('Could not save your email preference');
    }
  };

  if (enabled === null) return null;
  return (
    <Card className="card-dashboard" data-testid="weekly-update-card">
      <CardContent className="flex items-center justify-between gap-4 p-5">
        <div className="flex items-start gap-3">
          <Mail className="w-5 h-5 text-[#00E676] mt-0.5" />
          <div>
            <p className="text-white font-medium">Weekly investor update</p>
            <p className="text-sm text-gray-400">Tuesday 9 AM Eastern email about the businesses you own shares in.</p>
          </div>
        </div>
        <Switch checked={enabled} onCheckedChange={toggle} data-testid="weekly-update-switch" />
      </CardContent>
    </Card>
  );
};
